import React, {useEffect, useState} from 'react';
import {useParams, useLocation} from 'react-router-dom';
import {Link} from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// import required modules
import { Pagination } from "swiper";


function Photo(props) {
    const [on,setOn] = useState(false);
    const location = useLocation();
    const locationNum = location.pathname.split("/");
    useEffect(() => {
        if(locationNum[1] !== props.pageN.page) props.pageF(locationNum[1]);
        if(locationNum[1] !== props.pageN.page) props.pageF(locationNum[1]);
        console.log(locationNum)
        const timeOut = setTimeout(()=> setOn(true), 100);
        return () => clearTimeout(timeOut);
    });
    return (
        <div className={on ? "conBox on" : "conBox"}>
            <div className="topBg"></div>
            <div className="conTopWave">
                <div className="conTopWaveIn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6000" height="240" viewBox="0 0 6000 240" preserveAspectRatio="xMidYMid slice">
                        <pattern id="wave" width=".25" height="1.1" patternContentUnits="objectBoundingBox">
                        <path fill="#1A2C2D" d="M0.25,1H0c0,0,0-0.659,0-0.916c0.083-0.303,0.158,0.334,0.25,0C0.25,0.327,0.25,1,0.25,1z"></path>
                        </pattern>
                        <rect width="6000px" height="140"></rect>
                    </svg>
                </div>
                <div className="photoLeftBox">
                    <ul>
                        <li className="on"><Link to="/photo/2023">2023<span>Scattering of light</span></Link></li>
                        <li><Link to="/photo/2022">2022<span>Time and Space</span></Link></li>
                        <li><Link to="/photo/2018">2018<span>Solo Exhibition</span></Link></li>
                        <li><Link to="/photo/2016">2016<span>Gothic architecture</span></Link></li>
                        <li><Link to="/photo/2015">2015<span>Italian cathedral</span></Link></li>
                    </ul>
                </div>
            </div>
            <div className="pageNameBox">
                <div className="pageNameBoxIn">
                    <h2>PORTFOLIO</h2>
                    <p>Photo</p>
                </div>
            </div>
           
            <div className="photoConBoxIn">
                
                <div className="photoRightBox">
                    <ul>
                        <li>
                            <h3><span>2023</span> Scattering of light</h3>
                            <p>
                                <img src={process.env.PUBLIC_URL+"/assets/img/photo/2023_02.png"} className="photoRImg" alt="" />
                                <span>빛</span>은 산란한다. 질량이 없는 그것은 우리가 아는한 가장 빠른 속도로 날아와 물질에 부딪치고 산란하고 이내 사라진다. 빛이 무엇인지 정확히 알수는 없지만 적어도 우리는 극히 일부의 파장대에서 그것을 볼수 있다. <br/><br/>
                            우리가 본다는것, 느낀다는것, 안다는것들이 모두 다 이 빛으로부터 시작한다. 우리가 산다는 행위는 물리적인 3차원의 공간에서 이루워진다. 그리고 그곳은 빛으로 가득차있다. 사물을 본다는 것은 '빛과 공간' 이 두가지 요소가 동시에
                            필요하다. 그 공간안에 사물이 있다고 한다면 우리는 이것을 직접 마주하는것이 아니다. 그 사물에 빛을 보내 산란하는 빛을 보는것이다. 이는 '근원'을 보는것이 아니라 근원으로 인해 흔들리는 Simulacre를 보는것이다.<br/><br/>
                            빛은 산란한다. 그것은 거짓이 아니다. 그렇다고 근원도 아니다. 근원의 매개체일 뿐이다. 우리가 근원(진리)를 찾아나갈 수 있는 유일한 요소는 아쉽게도 '빛'이 전부다. 빛은 근원을 알수 있는 유일한(현재까지는) 열쇠이며 우리가 알 수 있는
                            근원적 한계의 끝에 존재한다. 장황하게 설명한 이러한 원리가 내가 사진을 찍는 이유에 대한 설명이며 변명이다. <br/><br/>
                            우리가 살고있는 공간속에는 다양한 패턴들이 존재한다. 동일한 조건에 동일한 법칙으로 동일한시간이 흐르고 나면 일종의 패턴들이 만들어지는데 이것을 포착하여 사진으로 담는다. 때로는 이것은 매우 기괴하며 때로는 아름답다.

                            </p>
                            <div className="imgBox">
                                <Swiper
                                    slidesPerView={'auto'}
                                    spaceBetween={0}
                                    pagination={{
                                    clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    className="photo_2023"
                                >
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2023_list_03.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2023_list_01.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2023_list_04.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2023_list_02.png"} alt="" /></SwiperSlide>
                                </Swiper>
                            </div>
                        </li>
                        <li>
                            <h3><span>2022</span> Time and Space</h3>
                            <p>
                                <span>시</span>간은 공간에 생명력을 부여한다. 원자적 관점에서 보면 나무, 건물, 도로등은 모양과 성질이 달라도 확대해보면 모두 원자들의 집합체에 불과하다. 시간의 흐름에 따라 집합체들은 융합과 분리를 끊임없이 진행하며 구조나 배치가 변경된다. 
                                우리는 이것을 '세월이 흘렀다'라고 표현한다. 다만 시간이 흐름에 따라 변화되어온 히스토리가 흔적으로 쌓이게되는데 히스토리는 그 공간에 생명력을 부여 한다. 시간의 흐름은 히스토리를 생산하고 생산된 히스토리는 공간을 가치있게 만든다는 뜻이다.<br/><br/>
                                예들들어 왕이 다녀간 길, 1000년이 넘은 나무, 겸제 정선의 수성동계곡이 그려진 돌다리등은 시간의 흐림에 의해 생겨난 특정 사건을 통해 가치를 부여받는다. 시간의 흐름에 따라 공간은 쉴세 없이 변화한다. 변화의 정도의 차이는 있을 수 있지만 변화를 거스르는 경우는 없다. 
                                그 변화는 매우 흔한일이며 그 과정에서 어떠한 사건 혹은 패턴들이 만들어지는데 이것을 인간의 기준으로 판단하여 중요한 것은 기록되어지고 그렇지 않는것은 잊혀진다. 다시말해 시간의 흐름에 따라 모든것이 변하지만 의미있는 것들만 재가공되어 우리에게 전달된다. <br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/photo/2022_01.png"} alt="" />
                                    <figcaption>수성동 옛길을 걸으면 시간을 만날 수 있다.</figcaption>
                                </figure>
                                시간이 흐르지 않으면 사건이 발생하지 않는다. 사건이 없다면 가치를 평가할 수 없고. 가치가 없다면 모두 잊혀진다. 잊혀진다고 해서 그것이 존재했었다는것을 부정하는것은 아니다. 그것은 분명이 있었으나 있었든 없었든 의미가 없다는 뜻이다.<br/><br/>
                                결국 의미있는것이 사진에 담긴다. 
                            </p>
                            <div className="imgBox">
                                <Swiper
                                    slidesPerView={'auto'}
                                    spaceBetween={0}
                                    pagination={{
                                    clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    className="photo_2023"
                                >
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2022_list_02.png"} alt="" /></SwiperSlide>
                                    
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2022_list_03.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide className="imgH"><img src={process.env.PUBLIC_URL+"/assets/img/photo/2022_list_05.png"} alt="" /></SwiperSlide>
                                </Swiper>
                            </div>
                        </li>
                        <li>
                            <h3><span>2018</span> Solo Exhibition</h3>
                            <p><span>빛</span>과 성당에 대한 주제로 다녀온 프랑스 여행기는 좋은 기회에 책으로 출간되었다. '빛은 성당이 되었다'라는 주제로 출간된 책과 함께 2018년 서울 대학로에서 개인전을 진행했다. 
                            2018 개인전은 2016년 프랑스 고딕성당에 대한 사진전으로 구성되었고, 약간의 미디어 작품들도 설치되었다. <br/><br/>
                            고딕성당은 가벼워졌고 높아졌다. 높아지는 성당은 바벨탑과 같은 인간의 욕망을 담고있었다고도 볼 수 있지만, 구조적으로는 높아진 면적을 통해 천고창(Clerestory)의 빛을 최대한 모으려는 장인들의 노력이기도 하다.
                            얇아진 벽과 빈공간은 빛으로 채워졌으니 빛은 성당이 되었다고 볼 수 있다. 프랑스 여행에서 나는 그 빛을 카메라에 담았다. 
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/photo/2018_01.png"} alt="" />
                                    <figcaption>2018 Solo Exhibition - 빛은 성당이 되었다</figcaption>
                                </figure>
                            </p>
                            <div className="imgBox">
                                <Swiper
                                    slidesPerView={'auto'}
                                    spaceBetween={0}
                                    pagination={{
                                    clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    className="photo_2015"
                                >
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2018_list_01.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2018_list_02.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2018_list_03.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2018_list_04.png"} alt="" /></SwiperSlide>
                                </Swiper>
                            </div>
                            <p><span>책</span>을 쓰기에 좋은 타이밍은 아니였다. 2018년도는 아들이 태어나기도 했고, 많은 일을 하고 있던 차였다. 
                            출퇴근은 편도로 2시간 정도가 걸렸는데 원고를 버스에서 쓸 목적으로 휴대용 블루투스 키보드를 구매했다. <br/><br/>
                            책 디자인, 원고는 모두 직접 작업을 진행했고, 원고 검수는 육아를 하고 있는 아내가 도왔다. 책에 사용된 사진은 100% 2016년 프랑스에서 직접 찍은 사진만 사용해서 책을 구성했다. 책은 성당을 중심응로 한 
                            직접 여행한 경험담을 담고있다. 1장 시테섬의 성당들 / 2장 파리와 루앙 성당 / 3장 프랑스 동부성당으로 구성되어 있으며 세상에서 가장 아름다운 성당으로 불리우는 생 에티엔 뒤 몽 성당에서 부터 이야기는 시작된다. 
                            <br/><br/>
                            책에는 고딕성당 이야기만 있는것은 아니다. 신고전주의 걸작으로 꼽히는 팡테옹, 바로그양식의 정수로 꼽피는 앵발리드에 대한 이야기도 들어있고 복잡한 도심을 벗어나 프랑스 동부로 이동해보면 독일 국경과 맞닿아 있는 알자스 지방에 대한 이야기도 있다.
                            알자스 지방은 파리의 모습과는 사뭇다르며 도시의 지명이나 성당,건물들의 양식 자체도 다르다. 유럽 여행을 다니면 편의점 보듯이 수많은 성당을 만날 수 있다. 비슷한듯 다른 모습을 하고 있는 성당을 비교해 보는 것은 유럽 여행의 또다른 묘미다. <br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/photo/2018_02.png"} alt="" />
                                    <figcaption>2018 B&C Books - 빛은 성당이 되었다</figcaption>
                                </figure>
                            </p>
                        </li>
                        <li>
                            <h3><span>2016</span> Gothic architecture</h3>
                            <p><span>빛</span>은 성당이 되었다. 카타콤이나 가정에서 몰래 예배를 드리던 음지의 기독교인들은 그리스도교가 공인이 되면서 양지로 나오게 되었다. 
                            하지만 점차 크고 웅장한 성당을 짖기위에 두껍고 좁은 창문을 사용하게 되었는데 성당 내부는 어두운 음지로 남았다. 이러한 좁고 어두운 로마네스크 양식을 뒤집을 아이디어가 프랑스에서 나오게 된다. 
                            12세기 프랑스는 스콜라 철학등이 발전하면서 기존과 다른 움직임들이 감지되기 시작했다. 건축에는 데가주망(degaement) 공법이 적용되고, 창의적인 아이디어가 모아지면서 동굴과도 같던 성당 내부는 점차 빛으로 차오르게 되었다. <br/><br/>
                            빛은 성당의 재료였고, 빛은 성당이 되었다. 나는 망설임없이 프랑스행 비행기 티켓을 끊었다. 빛으로 가득찬 성당을 조그만한 모니터의 다큐멘터리로 이해할 수는 없는일이였다. 
                            </p>
                            <div className="imgBox">
                                <Swiper
                                    slidesPerView={'auto'}
                                    spaceBetween={0}
                                    pagination={{
                                    clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    className="photo_2015"
                                >
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2016_list_01.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2016_list_02.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2016_list_03.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2016_list_04.png"} alt="" /></SwiperSlide>
                                </Swiper>
                            </div>
                            <p><span>스</span>테인드 글라스는 고딕성당의 꽃이다. 고딕의 건축학적 핵심은 리브볼트, 다발구조, 플라잉 버트레스등이라 말하겠지만 결국 이러한 구조들은 모두 빛을 성당내부로 끌어드리는 공통의 목적을 가지고 있다. 
                            빛은 그냥 내부로 들어오지 않는다. 외부의 빛은 스테인드글라스에 부딪쳐 살란한다. 그제서야 성당내부는 신비로운 빛으로 가득차게 되는것이다.<br/><br/>
                            파리 시태섬의 노트르담 대성당을 보았을때 예상했던 대로 어두웠다. 노트르담 대상당은 초기 고딕을 대표하는 건축물로 플라잉버트레스와 같은 신기술이 도입되었지만 성당내부의 빛은 고딕의 정점에 있지 않았다. 
                            노트르담 대성당에서 그리 멀지않은 곳에 생트샤펠이 있다. 규모는 상당히 작은 왕실 예배당이지만 이곳은 고딕의 정수로 평가된다. 성당의 모든 벽면에서 빛은 쏟아져 들어오고 빼곡히 들어찬 스테인드글라스에 의해 산란된다.
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/photo/2016_01.png"} alt="" />
                                    <figcaption>생트샤펠(Sainte-Chapelle) 스테인드 글라스</figcaption>
                                </figure>
                            </p>
                        </li>
                        <li>
                            <h3><span>2015</span> Italian cathedral</h3>
                            <p><span>2015</span>년 베네치아에 도착했을때 칠흑같은 밤이였다. 늦은시간 빠른 숙소를 가기 위해 바포레토(수상버스) 티켓을 끊었다. 
                            운하 위에서 바라본 도시의 건물들은 웅장하며 음침했고, 일렁이는 바다는 어둡고 반들거렸다. <br/><br/>
                            다음날 숙소에서 문을 열었을때 어제의 첫인상과는 다른 풍경이 펼쳐젔다. 그리고 이탈리아인들이 무엇에 미쳐 있었는지 단번에 알 수 있었다.  골목 사이사이에 편의점 처럼 흔하게 세워진 성당은 이들의 유구한 역사를 대변한다. 
                            벽돌사이의 이끼와 부서진 석상들에 이곳에서 일어난 수많은 히스토리를 간접적으로 느낄 수 있도록 해준다. <br/><br/>
                            이들은 수천년간 자신의 신념과 노동력을 이곳에 갈아넣었고 그것은 지금의 성당이 되었다. 
                            </p>
                            <div className="imgBox">
                                <Swiper
                                    slidesPerView={'auto'}
                                    spaceBetween={0}
                                    pagination={{
                                    clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    className="photo_2015"
                                >
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2015_list_01.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2015_list_02.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2015_list_03.png"} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={process.env.PUBLIC_URL+"/assets/img/photo/2015_list_04.png"} alt="" /></SwiperSlide>
                                </Swiper>
                            </div>
                            <p><span>판테온</span>은 돔의 시작이자 완성이다. 로마시대 장인들은 이 특별한 지붕을 설계하고 실연시켰다. 이 단순한 원형 천장은 누구나 쉽게 만들수 있는 구조물이 아니다. 
                            이탈리아가 돔의 성지가 된것은 판테온이 로마에 있었기 때문이다. 수많은 건축가, 예술가들은 이곳을 다녀갔고 그 이후 피렌체의 돔을, 베드로성당의 돔을 만들어냈다.<br/><br/>
                            판테온의 건립은 기원전 27년 일이다. 지금의 모습은 화제로 소실된 것을 서기 125년경 다시 세워진것인데 중요한건 이미 2000년전 이들은 완벽한 원형 지붕을 만들어냈다는 것이다. 
                            판테온 정 중앙에 서서 하늘을 바라봤을때 시간이 멈추는것을 경험을 했다. 무서울 정도로 대칭적이고 적막한 천장을 바라봤을때 소음은 사라지고 이내 시간은 정지했다.<br/><br/>
                                <figure>
                                    <img src={process.env.PUBLIC_URL+"/assets/img/photo/2015_01.png"} alt="" />
                                    <figcaption>판테온의 돔</figcaption>
                                </figure>
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
  
export default Photo;